import { Component, OnInit } from '@angular/core';
import { Http, Response } from '@angular/http';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';

@Component({
  selector: 'form-select',
  styleUrls: ['form-select.component.scss'],
  template: `
    <div 
      class="dynamic-field form-select"
      [ngClass]="{'required': required}" 
      [formGroup]="group">
      <label>{{ config.label }}</label>
      <select [formControlName]="config.name">
        <option value="">{{ config.placeholder }}</option>
        <option *ngFor="let option of config.options" value="{{option.Id}}">
          {{ option.Designation }}
        </option>
      </select>
    </div>
  `
})
export class FormSelectComponent implements OnInit, Field {
  config: FieldConfig;
  group: FormGroup;
  options: any;

  constructor(private http: Http) {
  }

  ngOnInit() {

    this.http
      .get(this.options.apiUrl + '/' + this.config.entity)
      .map(response => this.config.options = response.json())
      .catch(this.handleError)
      .subscribe();

  }

  private handleError(error: Response | any) {
    console.error('FormSelectComponent::handleError', error, this.config.entity);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-form/components/form-select/form-select.component.ts